import styled, { css } from "styled-components";

const DeliveryItemCardStyled = styled.div`
  width: 100%;
  padding: 16px;
  height: 104px;

  cursor: pointer;
  border-top: 1px solid #E0E0E0;

  .primaryField {
      display: flex;
        justify-content: space-between;
        gap: 16px;
        height: 44px;
        margin-bottom: 8px;
        position: relative;
    }

    .retailerInfoCard {
        display: flex;
        gap: 16px;
    }

    .secondaryField { 
        height: 20px;
    }

    .retailerNameHolder {
        font-size: 14x;
        font-weight: 400;
        color: #1B1E1C;
    }

    .itemNameHolder {
        font-size: 1.2rem;
        font-weight: 400;
        color: #757575;
    }

    .imagesWrapper { 
        display: flex;
        flex-direction: column;
        align-items: end;
        gap: 20px;

        & > img {
            width: 32px;
            height: 32px;
        }
    }

    .secondaryField  {
        padding-left: 48px;
        display: flex;
        align-items: center;

        & > div:nth-child(1) {
            font-size: 1.2rem;
            font-weight: 400;
            color: #757575;
        }
    }

    .secondaryFieldExtended {
        padding-left: 48px;
        display: flex;
        width: 50%;
        align-items: center;
        gap: 5px;

        & > .customAlertExtended {
            display: flex;
            align-items: center;
         }

        & > .description {
            font-size: 1.2rem;
            font-weight: 400;
            color: #757575;
        }
    }


   ${props => {
        return (
            props.selected &&
            css`
                background: #F0F9F3;
                border-radius: 8px;
                border: 1px solid #008755;

                .retailerNameHolder {
                    font-weight: 700;
                    color: #1B1E1C;
                }

                .itemNameHolder {
                    color: #3D4543;
                }

                .secondaryField .secondaryFieldExtended {
                    & > div:first-child {
                        color: #3D4543;
                    }
                }
     
            `
        );
    }}

${props => {
        return (
            props.extended &&
            css`

                height: 76px;
                max-width: 786px;

                .primaryField { 
                    align-items: center;
                }

                .retailerInfoCard {
                    width: 70%;
                    align-items: center;

                    & > div:nth-child(2) {
                            width: 45%;
                        }
                }

                .secondaryField  {
                   display: none;
                }

                .customsAlert {
                    display: none;
                }
     
            `
        );
    }}
`

export { DeliveryItemCardStyled };